import { formatCurrency } from "./constants";

Number.prototype.customToFixed = function(digits = 2) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (digits || -1) + "})?");

  if (this.toString().match(re) === null) {
    console.log("error", this);
  }

  return this.toString().match(re)[0];
};

Number.prototype.arrondi2Decimal = function() {
  try {
    return Math.round(this * 100) / 100;
  } catch (e) {
    console.log(e);
  }
};

Number.prototype.currency = function() {
  try {
    return formatCurrency(this);
  } catch (e) {
    console.log(e);
  }
};

//
// Number.prototype.toFixed = function (digits) {
//   var re = new RegExp('^-?\\d+(?:.\\d{0,' + (digits || -1) + '})?');
//
//   if (this.toString().match(re) === null) {
//   }
//
//
//   return this.toString().match(re)[0];
// };
